function ritualInformation() {
    let collapseBtn = document.querySelectorAll('.ritual__description__collapse-btn');
    let descContent = document.querySelectorAll('.ritual__description-content');

    collapseBtn.forEach((btn, index) => {
        btn.addEventListener('click', function() {
            console.log(descContent[index])
            descContent[index].classList.toggle('active-accordion')
            let realHeight = descContent[index].scrollHeight;

            if(descContent[index].offsetHeight <= 70) {
                descContent[index].style.maxHeight = realHeight + 'px'
                btn.classList.remove('act-btn');
                //btn.innerHTML = 'Read Less -';
            } else {
                descContent[index].style.maxHeight = '70px'
                btn.classList.add('act-btn');
                //btn.innerHTML = 'Read More +';
            }
            
        })
    })
}
ritualInformation()